module.exports = __webpack_public_path__ + "img/leighton_b3.e5e7601d.jpg";